import { useState } from "react";
import SectionHeader from "./SectionHeader";
import { faqItems } from "@/pages/home/data/faq";

export default function Faq() {
  const [openId, setOpenId] = useState<string>("faq-1");

  return (
    <section id="faq" className="bg-background-50">
      <div className="mx-auto max-w-[1280px] px-4 py-14 md:px-6 md:py-20">
        <div className="grid grid-cols-1 gap-8 lg:grid-cols-12">
          {/* left intro */}
          <div className="lg:col-span-4">
            <SectionHeader
              eyebrow="常见问题"
              title="关于塌房与粉丝反应，你常问的几个问题"
              description="从概念到吃瓜方法论，整理出被问得最多的六个问题，帮你更清醒地追热点。"
            />
            <div className="mt-6 rounded-xl bg-gradient-to-br from-primary-100 to-secondary-100 p-6">
              <span className="flex h-10 w-10 items-center justify-center rounded-lg bg-primary-500 text-background-50">
                <i className="ri-question-answer-line text-xl" aria-hidden="true"></i>
              </span>
              <h3 className="mt-4 font-heading text-lg font-bold text-foreground-950">还是没看明白？</h3>
              <p className="mt-2 text-sm leading-relaxed text-foreground-700">
                塌房舆论每天都在变化，欢迎订阅风向周报，每周收到编辑部整理的粉圈风向复盘。
              </p>
              <a
                href="#newsletter"
                className="mt-4 inline-flex items-center gap-1.5 whitespace-nowrap rounded-md bg-foreground-950 px-4 py-2.5 text-sm font-medium text-background-50 transition-colors hover:bg-foreground-800"
              >
                <i className="ri-mail-send-line" aria-hidden="true"></i>
                订阅风向周报
              </a>
            </div>
          </div>

          {/* accordion */}
          <div className="space-y-3 lg:col-span-8">
            {faqItems.map((item) => {
              const open = item.id === openId;
              return (
                <div
                  key={item.id}
                  className={`overflow-hidden rounded-xl border transition-colors ${
                    open ? "border-primary-300 bg-background-100" : "border-background-200 bg-background-50"
                  }`}
                >
                  <button
                    type="button"
                    aria-expanded={open}
                    onClick={() => setOpenId(open ? "" : item.id)}
                    className="flex w-full items-center justify-between gap-4 px-5 py-4 text-left"
                  >
                    <span className="flex items-center gap-3">
                      <span className="whitespace-nowrap rounded-full bg-accent-100 px-2.5 py-0.5 text-xs font-medium text-accent-800">
                        {item.tag}
                      </span>
                      <span className="text-[15px] font-medium leading-snug text-foreground-950">{item.q}</span>
                    </span>
                    <span
                      className={`flex h-7 w-7 shrink-0 items-center justify-center rounded-full transition-transform duration-300 ${
                        open ? "rotate-180 bg-primary-500 text-background-50" : "bg-background-200 text-foreground-700"
                      }`}
                    >
                      <i className="ri-arrow-down-s-line" aria-hidden="true"></i>
                    </span>
                  </button>
                  {open && (
                    <div className="border-t border-background-200 px-5 py-4">
                      <p className="text-sm leading-relaxed text-foreground-700">{item.a}</p>
                    </div>
                  )}
                </div>
              );
            })}
          </div>
        </div>
      </div>
    </section>
  );
}